import { zodResolver } from '@hookform/resolvers/zod';
import { Stack } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { OfferCard } from './components/offer-card';
import { PageContainer } from '@/components/shared/page-container';
import { UserDataForm } from '@/packages/courses/components/user-data-form';
import {
  registrationSchema,
  type RegistrationFormData,
} from '@/packages/courses/components/user-data-form/schema';

export const Registration = () => {
  const methods = useForm<RegistrationFormData>({
    resolver: zodResolver(registrationSchema),
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: {
      name: '',
      email: '',
      cpf: '',
      countryCode: '+55',
      phone: '',
      birthDate: '',
      cep: '',
      street: '',
      number: undefined,
      neighborhood: '',
      city: '',
      state: '',
      complement: '',
      no_number: false,
    },
  });

  return (
    <PageContainer>
      <FormProvider {...methods}>
        <Stack
          direction={{ sm: 'column', md: 'row' }}
          alignItems="flex-start"
          gap={4}
        >
          <UserDataForm />
          <OfferCard />
        </Stack>
      </FormProvider>
    </PageContainer>
  );
};
